angular.module("Main").directive("vRequired", vRequired);

function vRequired() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attr, ngModel) {
            var validationFunction = function (viewValue) {
                var valid = (!_.isNil(viewValue) && (!_.isEmpty(viewValue) || _.isNumber(viewValue) || _.isDate(viewValue) || viewValue === true));

                ngModel.$setValidity("vRequired", valid);

                return viewValue;
            };

            ngModel.$parsers.unshift(validationFunction);
            ngModel.$formatters.unshift(validationFunction);
        }
    }
}